import { FunctionComponent } from "react";

const InputField: FunctionComponent = () => {
  return (
    <div className="self-stretch bg-gray-800 overflow-y-auto shrink-0 flex flex-row flex-wrap items-center justify-center gap-[7px] min-h-[812px] max-w-full text-left text-45xl text-black font-racing-sans-one">
      <div className="w-[902px] flex flex-col items-start justify-start p-5 box-border max-w-full">
        <div className="self-stretch rounded-xl bg-gray-700 flex flex-col items-center justify-center py-0 px-2.5 box-border gap-[17px] max-w-full">
          <div className="self-stretch flex flex-row items-start justify-center py-0 px-5 box-border max-w-full">
            <div className="h-[428px] flex-1 relative tracking-[0.12em] flex items-center max-w-full mq450:text-19xl mq1050:text-32xl">
              <span>
                <p className="m-0">CONTACT US</p>
                <p className="m-0">TO GET ON OUR</p>
                <p className="m-0">EMAIL LIST</p>
              </span>
            </div>
          </div>
          <div className="self-stretch flex flex-row items-start justify-center py-0 px-5 box-border max-w-full text-13xl font-saira">
            <div className="h-[296px] flex-1 relative flex items-center max-w-full mq450:text-lgi mq1050:text-7xl">
              Lorem ipsum dolor sit amet consectetur. A pharetra ut tristique
              fermentum adipiscing vestibulum suspendisse. Dignissim integer
              blandit pellentesque quis eleifend elit. Scelerisque sit cursus
              tincidunt elit donec ante. Sed posuere et habitant cursus.
            </div>
          </div>
        </div>
      </div>
      <div className="h-[597px] w-[513px] flex flex-col items-end justify-start py-2.5 px-5 box-border max-w-full">
        <img
          className="w-[432px] relative max-h-full object-cover max-w-full"
          loading="eager"
          alt=""
          src="/mountaindraw@2x.png"
        />
      </div>
    </div>
  );
};

export default InputField;
